import MagnetBrandDashboardCard from "../../molecules/magnet/MagnetBrandDashboardCard";

type Props = {
  magnets: Magnet[];
};

export default function MagnetGrid({ magnets }: Props) {
  return (
    // eslint-disable-next-line max-len
    // <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2 2xl:grid-cols-3 md:grid-flow-row md:gap-x-5 md:gap-y-5 mb-20">
    // <div className="flex flex-wrap w-full mb-20 space-x-3 space-y-5">
    <div className="grid grid-cols-2 gap-4 pb-10 2xl:grid-cols-2 4xl:grid-cols-3">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {magnets && magnets.map((magnet) => <MagnetBrandDashboardCard key={`mag_dash_card${magnet.id}`} {...magnet} />)}
    </div>
  );
}
